import { combineReducers } from "redux";
import * as types from "./types";
import { parseQueryString, removeTrailingSlash } from "./utils";

const routerReducer = (
  state = { location: { hash: "#/" }, action: "" },
  action
) => {
  switch (action.type) {
    case types.UPDATE_HISTORY:
      const hash = action.data.location.hash;
      const searchParams = parseQueryString(
        removeTrailingSlash(action.data.location.search)
      );
      const hashParams = parseQueryString(hash);
      if (hashParams["q"]) {
        hashParams["q"] = encodeURIComponent(hashParams["q"]);
      }

      const allParams = { ...searchParams, ...hashParams };
      const search =
        "?" +
        Object.keys(allParams)
          .reduce((acc, key) => {
            acc.push(`${key}=${allParams[key]}`);
            return acc;
          }, [])
          .join("&");
      return {
        ...action.data,
        updateTime: new Date().valueOf(),
        location: {
          ...action.data.location,
          search,
          hash: hash.split("?")[0]
        }
      };
    default:
      return state;
  }
};

export default routerReducer;
